import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { FaExclamationCircle } from 'react-icons/fa';

const handleKeyDown = event => {
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault(); // Evita que se agregue el salto de línea predeterminado
    const textarea = event.target;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const value = textarea.value;
    const newValue = value.substring(0, start) + '\n' + value.substring(end);
    textarea.value = newValue;
    textarea.selectionStart = start + 1;
    textarea.selectionEnd = start + 1;
  }
};

export const Description = ({ touched, errors }) => (
  <>
    <div>
      <p className="alert alert-warning small">
        <FaExclamationCircle /> <strong>Atención</strong>
        <br />
        Por favor, no poner en el campo <strong>Descripción</strong> datos de
        contacto/comerciales de la inmobiliaria: (nombres, nombre de la
        inmobiliaria, teléfonos, número de matrícula o cualquier otro dato que
        identifique a la inmobiliaria) ya que si comparte este propiedad no se
        puede enviar por otro colega.
      </p>
    </div>
    <div className="w-100 mb-2">
      <label>Descripción *</label>

      <Field
        style={{ resize: 'none' }}
        className="form-control w-100"
        rows="16"
        name="description"
        component="textarea"
        onKeyDown={handleKeyDown}
      />
      {errors.description && touched.description && (
        <label className="w-100 text-danger">{errors.description}</label>
      )}
    </div>
  </>
);

Description.propTypes = {
  touched: PropTypes.object,
  errors: PropTypes.object
};
